import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    errorMessage: {
      padding: theme.spacing(0, 2),
    },
    select: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 0,
      marginBottom: 0,
    },
    root: {
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      paddingTop: '34px',
    },
  };
};
